<template>
    <div class="Mobiles">
        <Mobileheader name="加入我们" routeNmae="/join"  v-if="$store.state.isMobile !== 3"/>
        <div class="headers">
            <img class="banner" src="@/assets/img/join/recruitment.png" alt="" />
            <img class="Text animate__animated animate__zoomIn" src="../../assets/img/join/title.png" alt="" />
        </div>
        <div class="topTitle">
            <div class="chinese">热招职位</div>
            <div class="english">HOT RECRUITMENT POSITIONS</div>
        </div>
        <div class="titouter">

            <div class="titouterlist">
                <div class="item" @click="toOther()">社会招聘入口</div>
                <div class="item" @click="toOther()">24校招生招聘入口</div>
                <div class="item" @click="toOther()">实习生招聘入口</div>
            </div>
        </div>
        <div style="width: 100%;overflow-x: hidden;">
            <div class="example flexCenter">
                <swiper class="swiper" v-bind:options="swiperOption">
                    <swiper-slide class="slide">
                        <div class="item">
                            <img src="@/assets/img/join/activity.png" alt="" />
                            <div>金秋九月共庆生</div>
                        </div>
                    </swiper-slide>
                    <swiper-slide class="slide">
                        <div class="item">
                            <img src="@/assets/img/join/activity2.png" alt="" />
                            <div>校招培训</div>
                        </div>
                    </swiper-slide>
                    <swiper-slide class="slide">
                        <div class="item">
                            <img src="@/assets/img/join/activity4.png" alt="" />
                            <div>舞台表演</div>
                        </div>
                    </swiper-slide>
                    <swiper-slide class="slide">
                        <div class="item">
                            <img src="@/assets/img/join/activity5.png" alt="" />
                            <div>学习活动</div>
                        </div>
                    </swiper-slide>
                    <swiper-slide class="slide">
                        <div class="item">
                            <img src="@/assets/img/join/activity6.png" alt="" />
                            <div>活动聚餐</div>
                        </div>
                    </swiper-slide>
                    <swiper-slide class="slide">
                        <div class="item">
                            <img src="@/assets/img/join/activity7.png" alt="" />
                            <div>集体培训</div>
                        </div>
                    </swiper-slide>
                    <swiper-slide class="slide">
                        <div class="item">
                            <img src="@/assets/img/join/activity9.png" alt="" />
                            <div>户外锻炼</div>
                        </div>
                    </swiper-slide>
                    <swiper-slide class="slide">
                        <div class="item">
                            <img src="@/assets/img/join/activity10.png" alt="" />
                            <div>发布会</div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
// import {
// 	getProductProgrammeList
// } from "@/api/web.js"
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getProductProgrammeList } from "@/api/solutio";
import MobileSwiper from "@/components/mobileSwiper"
import FlexTop from "@/components/flexTop"
export default {
    components: {
        MobileSwiper,
        FlexTop,
        swiper,
        swiperSlide,
    },
    data() {
        return {
            swiperOption: {
                loop: true, // 是否循环
                autoplay: {
                    delay: 2500, // 自动播放的时长
                },
                speed: 2500,
                slidesPerView: "auto", // 设置可视区一共显示几张图片,设置auto,设置auto为自适应;
                centeredSlides: true, // 设置为true时,带有active-slide类名的图片会居中
                spaceBetween: 40, //  每张图片之间的间隔
            },
        };
    },
    mounted() {

    },
    methods: {
        handleClick(e) {

        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:767px) {

    .headers {
    position: relative;
    width: 100%;
    overflow: hidden;

    .banner {
        width: 1200px;
        height: 480px;
    }

    .Text {
        width: 400px;
        position: absolute;
        top: 130px;
        left: 50%;
        margin-left: -200px;
    }
}

.topTitle {
    text-align: center !important;
    color: #00398a;
    padding: 20px;
    text-align: center;

    .chinese {
        font-size: 34px;
    }

    .english {
        font-size: 24px;
        margin-top: 10px;
    }
}

.titouter {
    margin-top: 50px;
    width: 800px;

    .titouterlist {
        width: 100%;

        padding: 0 20px;
        box-sizing: border-box;
        overflow: hidden;

        .item {
            width: 100%;
            height: 80px;
            background: url(../../assets/img/join/base.png);
            background-size: 100% 100%;
            text-align: center;
            font-size: 28px;
            line-height: 80px;
            font-weight: 400;
            color: #f8f8f8;
            cursor: pointer;
            box-sizing: border-box;
            margin-bottom: 30px;
            margin-left: -30px;

        }

        .item:hover {
            font-weight: 900;
        }
    }
}

.example {
    flex-direction: row;
    margin-top: 50px;
    width: 100%;
    overflow: hidden;
   

    .item {
        // width: 325px;
        width: 100%;
        margin: 0 10px;
        border: 4px solid #ffffff;
        box-shadow: 0px 2px 8px 0px rgba(155, 206, 253, 0.48);

        img {
            width: 100%;
        }

        >div {
            font-size: 25px;
            font-family: Source Han Sans CN;
            font-weight: 600;
            color: #333333;
            line-height: 27px;
            background: #fff;
        }
    }
}

.swiper {
    width: 100%;

    .slide {
        width: 80%;
    }

}

::v-deep .swiper-slide {
    margin-right: 20px !important;
}
}</style>